import * as React from "react";
import {
  Container,
  ListGroup,
  ListGroupItem,
  BreadcrumbItem,
  Breadcrumb
} from "reactstrap";
import { SystemDetail } from "./SystemDetail";
import { Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { systemsAction } from "../../_actions";
import { Loading } from "../Loading";

const SystemList = ({data}:any) => {
  const renderList = () => {
    return data.data.map((data: any) => {
      return (
        <ListGroupItem key={data.id}>
          <SystemDetail {...{data: data}} />
        </ListGroupItem>
      );
    });
  };

  return (
      <ListGroup className="system-list">{renderList()}</ListGroup>
  );
};

class SystemsListState extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.props.load();
  }

  render() {
    const { systems, t} = this.props;

    if (systems.loading || systems.data == []) {
      return <Loading />;
    }

    return (
      <Container>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">Sypal</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>{t("system_list")}</BreadcrumbItem>
        </Breadcrumb>
        <SystemList data={systems} />
      </Container>
      )
  }
}

const mapStateToProps = (state: any) => {
  return {
    systems: state.systems
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      load: systemsAction.loadSystems
    },
    dispatch
  );
};

const SystemListComponent = compose(
  withTranslation('systems'),
  connect(mapStateToProps,mapDispatchToProps)
)(SystemsListState);

export { SystemListComponent as SystemList };
